import React from 'react'
import List, { IIconBullet } from '../../List'

import Typography from '@mui/material/Typography'

const listData: IIconBullet[] = [
  {
    title: 'Test med kabel i stedet for på wi-fi',
    description: 'Så får du en mere præcis måling',
    icon: {
      iconImage: {
        file: {
          fileName: 'Cable_lan_ethernet.svg',
        },
      },
    },
  },
  {
    title: 'Tester du på wi-fi?',
    description: 'Så sørg for at stå én meter fra dit router under målingen',
    icon: {
      iconImage: {
        file: {
          fileName: 'Wifi.svg',
        },
      },
    },
  },
  {
    title: 'Test gerne et par gange for at være sikker på resultatet',
    description: 'Så får du en mere præcis måling',
    icon: {
      iconImage: {
        file: {
          fileName: 'Refresh.svg',
        },
      },
    },
  },
]

const AdviceList = () => {
  return (
    <>
      <Typography style={{ marginBottom: '1rem' }} variant="h4" component="h2">
        3 gode råd, før du tager testen
      </Typography>
      <List id="3-gode-raad" listItems={listData} />
      <Typography variant="caption">
        * Hastighedstesten understøtter pt. ikke Internet Explorer. Vi
        anbefaler, at du bruger Chrome eller Safari.
      </Typography>
    </>
  )
}

export default AdviceList
